var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KinesisContainer',[_c('KinesisElement',{staticClass:"box-3d box",attrs:{"strength":_vm.strength,"type":"depth"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }